<template>
  <div class="flex flex-col gap-4">
    <ul class="p-0 m-0 flex flex-col gap-3 w-full">
      <li>
        <label class="text-[16px] font-lato font-medium leading-[1.5] text-[#999999]">Quote ID:</label>
        <p class="m-0 text-[16px] font-lato font-medium leading-[1] text-[#333333]">
          {{ quoteDetail.id }}
        </p>
      </li>
      <li v-if="isPartnerQuote">
        <label class="text-[16px] font-lato font-medium leading-[1.5] text-[#999999]">Claim ID:</label>
        <p class="m-0 text-[16px] font-lato font-medium leading-[1] text-[#333333]">
          {{ quoteDetail.partner_info.job_number }}
        </p>
      </li>
      <li>
        <label class="text-[16px] font-lato font-medium leading-[1.5] text-[#999999]">Consumer Name:</label>
        <p class="m-0 text-[16px] font-lato font-medium leading-[1] text-[#333333]">
          {{ quoteDetail.consumer.full_name }}
        </p>
      </li>
    </ul>
    <NoteModal class="hidden laptop:block" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import NoteModal from "./noteBox.vue";

export default {
  components: {
    NoteModal,
  },

  data() {
    return {};
  },
  computed: {
    ...mapGetters(["quoteDetail", "apptDetail"]),

    isPartnerQuote() {
      return (this.quoteDetail?.partner_info?.id > 0 && this.quoteDetail?.partner_info?.status != '0') || false
    }
  },

  watch: {},

  mounted() {
  
  },

  methods: {

  },
};
</script>
